import React from "react";

// Styles //
import "./thumbnailImage.scss";

interface ThumbnailImageProps {
    src: string;
    alt: string;
}

const ThumbnailImage = ({ src, alt }: ThumbnailImageProps) => {
    return (
        <div className="thumbnail-image">
            <img src={src} alt={src} />
        </div>
    );
};

export default ThumbnailImage;
